import FormDrawer from '../form-drawer/form-drawer.component';
import { t } from 'i18next';
import { Typography, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useState } from 'react';
import { useRedeemLoyaltyPointsMutation } from 'api/loyalty-domain/loyalty-domain';
import { useLoyaltyForm } from 'components/forms/loyalty-points-form/loyalty-points-form.hooks';
import LoyaltyPointsForm from 'components/forms/loyalty-points-form/loyalty-points-form.component';

const AdjustLoyaltyPointsDrawer = ({ open, close, drawerData }) => {
  const { form } = useLoyaltyForm();

  const [alignment, setAlignment] = useState('reward');

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string,
  ) => {
    setAlignment(newAlignment);
  };

  const [
    redeemLoyaltyPointsMutation,
    { isLoading: updateLoyaltyPointsLoading },
  ] = useRedeemLoyaltyPointsMutation();

  const submit = async data => {
    try {
      const body = {
        ...data,
        alignment,
      };
      await redeemLoyaltyPointsMutation({
        userId: drawerData?.customerId,
        body: body,
      });
      close();
      form.reset();
    } catch (_e) {}
  };

  const cancel = () => {
    close();
    form.reset();
  };

  return (
    <FormDrawer
      title={t('page.customers.card.adjustLoyaltyPoints')}
      submitButtonLabel={t('page.customers.card.adjustPointsSubmitButtonLabel')}
      data-testid="LoyaltyPointsDrawer.Drawer"
      open={open}
      onClose={cancel}
      onValid={submit}
      cancel={cancel}
      formMethods={form}
      isLoading={updateLoyaltyPointsLoading}
    >
      <Typography variant="h6">
        {t('page.customers.form.loyalty.adjustment')}
      </Typography>
      <ToggleButtonGroup
        fullWidth
        color="primary"
        value={alignment}
        exclusive
        onChange={handleChange}
        sx={{ marginTop: '5px' }}
      >
        <ToggleButton
          value="reward"
          sx={{
            textTransform: 'capitalize',
          }}
        >
          {t('page.customers.form.loyalty.addPoints')}
        </ToggleButton>
        <ToggleButton
          value="cost"
          sx={{
            textTransform: 'capitalize',
          }}
        >
          {t('page.customers.form.loyalty.removePoints')}
        </ToggleButton>
      </ToggleButtonGroup>
      <LoyaltyPointsForm />
    </FormDrawer>
  );
};

export default AdjustLoyaltyPointsDrawer;
